// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"7bc504ec","96":"6e1583d4","361":"333717c9","507":"3a459611","528":"93f7963d"}[chunkId] + ".css";
};